"use strict";

var _interopRequireDefault = require("/var/www/html/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _comComponent = _interopRequireDefault(require("../../common/com-component"));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default2 = exports.default = {
  components: {
    ComComponent: _comComponent.default
  },
  name: 'banner组件',
  props: {
    id: {
      default: function _default() {
        return '1-1';
      }
    },
    keyId: {}
  },
  methods: {
    onLocation: function onLocation(url_config) {
      console.log(1111111, url_config);
      this.$refs.comComponent.onLocation(url_config);
    }
  }
};